/**
 * Format a date string (YYYY-MM-DD) as ISO 8601 for API start of day (00:00:00.000Z).
 * Used for success-rate and other dashboard-metric APIs.
 */
export function toStartOfDayISO(dateStr: string): string {
  if (!dateStr) return '';
  return `${dateStr}T00:00:00.000Z`;
}

/**
 * Format a date string (YYYY-MM-DD) as ISO 8601 for API end of day (23:59:59.999Z).
 * Used for success-rate and other dashboard-metric APIs.
 */
export function toEndOfDayISO(dateStr: string): string {
  if (!dateStr) return '';
  return `${dateStr}T23:59:59.999Z`;
}
